import { NSARouterMakerResult } from "namirasoft-account-react";
import { ChatInferencerType, InferencerType } from "namirasoft-inference";
import { NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { Component } from "react";
import ChatList from "../components/ChatList";
import InferencerGraph from "../components/InferencerGraph";
import InferencerLoader from "../components/InferencerLoader";
import InferencerVisualizer from "../components/InferencerVisualizer";
import UsageChart from "../components/UsageChart";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface RaceViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class RaceViewPage extends Component<RaceViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.race.view }}
                pages={{
                    entity: InferenceEntities.race(this.props),
                    view: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Chats",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) => model.id
                                                    ? <ChatList
                                                        {...this.props}
                                                        inferencer_type={ChatInferencerType.RACE}
                                                        inferencer_id={model.id}
                                                    />
                                                    : null,
                                            },
                                            {
                                                title: "Usage",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) => model.id
                                                    ? <UsageChart
                                                        {...this.props}
                                                        inferencer_type={InferencerType.RACE}
                                                        inferencer_id={model.id}
                                                    />
                                                    : null,
                                            },
                                        ],
                                    },
                                },
                            },
                            getChildrenAfter: (id, _row) => id
                                ? <>
                                    <NSSpace size={NSSpaceSizeType.SMALL} />
                                    <InferencerLoader
                                        {...this.props}
                                        inferencer_type={InferencerType.RACE}
                                        inferencer_id={id}
                                        render={({ tree, loading, error }) => (
                                            <>
                                                <InferencerGraph tree={tree} loading={loading} error={error} />
                                                <NSSpace size={NSSpaceSizeType.SMALL} />
                                                <InferencerVisualizer tree={tree} loading={loading} error={error} />
                                            </>
                                        )}
                                    />
                                </>
                                : null,
                        },
                    }
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}